import React, { useEffect } from 'react';
import { ROUTE } from 'constant';
import Shared from 'screens/shared';
import { actions } from 'redux/actions';
import ResourceAllocation from './resource-overview';

import MongodbList from './mongodb/index';
import PostgresqlList from './postgresql/index';

export default ({ history }) => {
  useEffect(() => {
    actions.database.getQuota();
  }, []);

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.DATABASES}
      isStrap={false}
    >
      <ResourceAllocation />
      <PostgresqlList history={history} />
      <div style={{ height: '25px' }} />
      <MongodbList history={history} />
    </Shared.widgets.Page>
  );
};
